<template>
  <form class="flex justify-between search-form" @submit.prevent="handleSubmit">
    <input
      ref="search"
      :value="value"
      class="search w-full"
      type="search"
      placeholder="Hit F to search"
      @input="handleInput"
    />
    <button class="search-btn flex justify-center items-center">
      <svg
        width="30"
        height="30"
        fill="#aaa"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        ></path>
      </svg>
    </button>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      search: "",
      debounceId: null,
    }
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.focusSearch, false)
  },
  created() {
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  mounted() {
    document.addEventListener("keyup", evt => this.focusSearch(evt))
  },
  methods: {
    handleInput(e) {
      this.search = e.target.value
      clearTimeout(this.debounceId)
      this.debounceId = setTimeout(() => {
        this.handleSubmit()
      }, 500)
    },
    handleSubmit() {
      this.$emit("SEARCH", { text: this.search.trim() })
    },
    focusSearch(evt) {
      {
        const blackListedTags = ["textarea", "input"]
        const nodeName = evt.target.nodeName.toLowerCase()

        if (
          evt.code === "KeyF" &&
          !evt.target.isContentEditable &&
          !blackListedTags.includes(nodeName) &&
          this.$refs.search
        ) {
          this.$refs.search.focus()
        } else if (
          evt.code === "Escape" &&
          this.$refs.search &&
          document.activeElement === this.$refs.search
        ) {
          this.$refs.search.blur()
        }
      }
    },
  },
}
</script>

<style scoped>
.search-form {
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 2px 1px -1px #00000033, 0 1px 1px 0 #00000024,
    0 1px 3px 0 #0000001f;
  transition: box-shadow 0.3s ease-out;
}

.search-form:focus-within {
  box-shadow: 0 2px 5px 0 grey;
}

.search-btn {
  width: 5rem;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background: #eee;
}

.search {
  margin: 0;
  padding: 1rem;
  border: none;
}
</style>
